import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from 'react-simple-captcha';
import { Formik, Form, Field } from 'formik';
import InputField from 'customField/InputField';
import NewDesign from 'components/NewDesign';
import { CommonIcons } from 'components/Icons';
import useTheme from 'hooks/useTheme';
import { useStyles } from 'providers/ThemeProvider';

const propTypes = {
  onVerifySuccess: PropTypes.func,
};

const SimpleCaptcha = ({ onVerifySuccess }) => {
  //! State
  const { isDarkTheme } = useTheme();
  const { colorsSystem } = useStyles();

  useEffect(() => {
    setTimeout(() => {
      let colorText = isDarkTheme ? 'white' : 'black';
      let colorBackground = isDarkTheme ? 'rgb(30, 30, 30)' : 'white';
      loadCaptchaEnginge(6, colorBackground, colorText);
    }, 300);
  }, [isDarkTheme]);

  //! Function
  const onSubmit = (values, { setFieldValue }) => {
    const { value } = values;

    if (validateCaptcha(value)) {
      setFieldValue('isSuccess', true);
      onVerifySuccess && onVerifySuccess();
    }
  };

  const onKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  //! Render
  return (
    <Formik initialValues={{ value: '', isSuccess: false }} onSubmit={onSubmit}>
      {({ values, handleSubmit }) => (
        <Form className='d-flex default-border p-2 flex-column' onKeyDown={onKeyDown}>
          <LoadCanvasTemplateNoReload />

          <div className='d-flex align-items-center' style={{ gap: 8 }}>
            <div>
              <Field
                component={InputField}
                name='value'
                placeholder='XXXXXX'
                disabled={values.isSuccess}
              />
            </div>

            {values.isSuccess ? (
              <CommonIcons.Checked size={32} color={colorsSystem.brandSuccess} />
            ) : (
              <NewDesign.Button onClick={handleSubmit} disabled={values.isSuccess}>
                Verify
              </NewDesign.Button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

SimpleCaptcha.propTypes = propTypes;
export default React.memo(SimpleCaptcha);
